export const hasDefinedNonNullProps = (object: any, props: string[]) => {
  return (
    props.filter(
      prop => object?.[prop] !== undefined && object?.[prop] !== null,
    ).length === props.length
  )
}
